var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7875 4.3028C12.5792 4.10892 12.2967 4 12.0022 4C11.7077 4 11.4253 4.10892 11.217 4.3028L7.32966 7.92255C7.17285 8.06696 7.06576 8.25158 7.02204 8.45288C6.97832 8.65417 6.99995 8.86303 7.08418 9.05284C7.16841 9.24264 7.31142 9.4048 7.49498 9.51864C7.67854 9.63249 7.89435 9.69287 8.1149 9.69208H10.0586C10.0951 9.69195 10.1312 9.69854 10.165 9.71149C10.1988 9.72443 10.2294 9.74347 10.2552 9.76751C10.2811 9.79154 10.3015 9.8201 10.3154 9.85153C10.3293 9.88296 10.3364 9.91665 10.3362 9.95064V17.4487C10.3362 17.8601 10.5118 18.2547 10.8242 18.5456C11.1366 18.8366 11.5604 19 12.0022 19C12.4441 19 12.8678 18.8366 13.1803 18.5456C13.4927 18.2547 13.6682 17.8601 13.6682 17.4487V9.95064C13.6681 9.91665 13.6752 9.88296 13.6891 9.85153C13.703 9.8201 13.7234 9.79154 13.7492 9.76751C13.775 9.74347 13.8057 9.72443 13.8395 9.71149C13.8732 9.69854 13.9094 9.69195 13.9459 9.69208H15.8896C16.1092 9.69204 16.3239 9.63136 16.5065 9.51772C16.6891 9.40407 16.8314 9.24257 16.9155 9.05362C16.9995 8.86467 17.0215 8.65676 16.9787 8.45617C16.9358 8.25558 16.8301 8.07132 16.6748 7.92668L12.7875 4.3028Z",
    fill: "#EEF5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.055cfe3893de5f3bdf067223687868fc.svg";
export { ForwardRef as ReactComponent };